import { styled, Box, Typography, Tooltip } from "@mui/material";

export const SegmentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  // CONSISTENCY-PASS (Gordon 2026-08-18): tightened, consistent vertical gaps
  // between the pane's sections (was 25/20/18/15) so the pane reads snug.
  gap: "16px",
  width: "100%",
  minWidth: "280px",
  padding: "0 16px",

  // Responsive adjustments for zoom scenarios
  "@media (max-width: 1400px)": {
    gap: "14px",
    padding: "0 12px",
  },

  "@media (max-width: 1200px)": {
    gap: "12px",
    minWidth: "260px",
    // maxWidth: "400px",
  },

  "@media (max-width: 900px)": {
    gap: "10px",
    minWidth: "240px",
    // maxWidth: "350px",
    padding: "0 8px",
  },
  // width: "455px",
  // minHeight: "94vh",
  // height: "100%",
  // scrollY: "auto",
  // backgroundColor: "white",
  // zIndex: 1000,
  // borderRadius: "4px",
  // boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.1)",
  // padding: "16px 0px 0px 0px",
});

export const SegmentHeaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "1px solid #DED8E1",
  paddingBottom: "15px",
  marginBottom: "10px",
  marginTop: "10px",

  // Responsive adjustments for zoom scenarios
  "@media (max-width: 1400px)": {
    paddingBottom: "12px",
    marginBottom: "8px",
  },

  "@media (max-width: 1200px)": {
    paddingBottom: "10px",
    marginBottom: "6px",
    marginTop: "8px",
  },

  "@media (max-width: 900px)": {
    paddingBottom: "8px",
    marginBottom: "5px",
    marginTop: "6px",
  },
});

export const SegmenSettingstTitle = styled(Typography)({
  fontFamily: "DM Sans",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "20px",
  textAlign: "left",

  // Responsive font sizing for zoom scenarios
  "@media (max-width: 1200px)": {
    fontSize: "18px",
    lineHeight: "18px",
  },

  "@media (max-width: 900px)": {
    fontSize: "16px",
    lineHeight: "16px",
  },
});

export const SegmentSettingsIcon = styled("img")({
  width: "32px !important",

  // Responsive sizing for zoom scenarios
  "@media (max-width: 1200px)": {
    width: "28px !important",
  },

  "@media (max-width: 900px)": {
    width: "24px !important",
  },
});

export const SegmentSubTitle = styled(Typography)(({ color = "#123051" }) => ({
  fontFamily: "DM Sans",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "20px",
  textAlign: "left",
  color,

  // Responsive font sizing for zoom scenarios
  "@media (max-width: 1200px)": {
    fontSize: "14px",
    lineHeight: "18px",
  },

  "@media (max-width: 900px)": {
    fontSize: "12px",
    lineHeight: "16px",
  },
}));

export const SegmentTitleEmoji = styled("img")({
  width: "24px !important",
  height: "28px",
  cursor: "pointer",
});

const ToBeStyledTooltip = ({ className, ...props }) => (
  <Tooltip {...props} classes={{ tooltip: className }} />
);
export const SegmentSizeTooltip = styled(ToBeStyledTooltip)({
  backgroundColor: "#D4E2F2",
  color: "#123051",
  width: "120px",
  fontSize: "12px",
  fontWeight: "500",
  padding: "4px, 8px, 4px, 8px",

  "& .MuiTooltip-arrow": {
    color: "#D4E2F2",
  },
});
